module.exports = __webpack_public_path__ + "img/7c035bc.svg";